import { useNavigate } from "react-router-dom";
import { Lock, Sparkles, Check } from "lucide-react";

export default function SubscribeCTA({ title, subtitle, className = "" }) {
  const navigate = useNavigate();
  return (
    <div className={`rounded-2xl border border-blue-500/30 bg-blue-600/[0.07] p-6 text-center ${className}`} data-testid="subscribe-cta">
      <div className="w-11 h-11 rounded-xl bg-blue-600/20 border border-blue-500/30 flex items-center justify-center mx-auto mb-3">
        <Lock className="w-5 h-5 text-blue-400" />
      </div>
      <h3 className="font-display text-lg font-semibold mb-1.5">{title || "Subscribe to unlock"}</h3>
      <p className="text-sm text-slate-400 mb-4 max-w-md mx-auto">{subtitle || "Free accounts get 3 searches, view-only. Go Pro for unlimited searches and PDF + Excel downloads."}</p>
      <div className="flex items-center justify-center gap-3 mb-4 text-sm">
        <span className="flex items-center gap-1.5 text-slate-300"><Check className="w-4 h-4 text-blue-400" /> $12/month</span>
        <span className="text-slate-600">or</span>
        <span className="flex items-center gap-1.5 text-slate-300"><Check className="w-4 h-4 text-blue-400" /> $99/year <span className="text-[10px] text-emerald-400 font-mono-niq">save 31%</span></span>
      </div>
      <button onClick={() => navigate("/billing")} data-testid="subscribe-cta-button" className="inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-500 px-5 py-2.5 rounded-lg text-sm font-medium transition-colors">
        <Sparkles className="w-4 h-4" /> Go Pro
      </button>
    </div>
  );
}
